(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("antd"), require("antdCssinjs"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "antd", "antdCssinjs"], factory);
	else if(typeof exports === 'object')
		exports["antdx"] = factory(require("React"), require("ReactDOM"), require("antd"), require("antdCssinjs"));
	else
		root["antdx"] = factory(root["React"], root["ReactDOM"], root["antd"], root["antdCssinjs"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__1024__, __WEBPACK_EXTERNAL_MODULE__314__, __WEBPACK_EXTERNAL_MODULE__2721__, __WEBPACK_EXTERNAL_MODULE__781__) {
return 